import { LUDUM_ERROR_CODES } from '@/constants';
import { ROUTES_WELCOME, ROUTES_CREATE_CLUB } from '@/constants/routes';
import router from '@/router';

// Determines if an error should be shown in the console or not.
function shouldThrow(error) {
    return error && ![LUDUM_ERROR_CODES.NO_CLUBS].includes(error.status_code);
}

const resolves = {};
const rejects = {};
let globalMsgId = 0;
/**
 * send a request to server using web worker
 * @param {*} payload
 * @param {Worker} worker
 */
export function request(payload, worker) {
    payload.config = _.merge({}, getAxiosConfig(), payload.config);

    const msgId = globalMsgId++;
    const msg = {
        id: msgId,
        payload
    };
    return new Promise(function (resolve, reject) {
        // save callbacks for later
        resolves[msgId] = resolve;
        rejects[msgId] = reject;
        worker.postMessage(msg);
    });
}
// Handle incoming calculation result
export function handleResponse(msg) {
    const { id, error, payload } = JSON.parse(msg.data);

    // find a resolve or reject and execute the callback for request with id
    if (payload) {
        const data = { ...payload.data, responseURL: payload.responseURL };
        resolves[id] && resolves[id](data);
    } else {
        // Handle NO_CLUBS status globally - redirect to welcome page
        if (error && error.status_code === LUDUM_ERROR_CODES.NO_CLUBS) {
            const currentRoute = router.currentRoute.name;
            if (![ROUTES_WELCOME, ROUTES_CREATE_CLUB].includes(currentRoute)) {
                router.push({ name: ROUTES_WELCOME }).catch(() => {});
            }
        }

        if (shouldThrow(error)) {
            let msg = error ? error : 'No response';
            rejects[id] && rejects[id](msg);
        }
    }
    // purge used callbacks
    delete resolves[id];
    delete rejects[id];
}

/**
 * Get proper configuration for a request
 */
export function getAxiosConfig() {
    if (Vue.auth.isAuthenticated()) {
        return {
            headers: {
                Authorization: 'Bearer ' + Vue.auth.getToken(),
                'Accept-Language': Vue.cookie && Vue.cookie.get('language') ? Vue.cookie.get('language') : 'en',
                'club-id':
                    Vue.cookie && Vue.cookie.get('selectedClub')
                        ? Number.parseInt(Vue.cookie.get('selectedClub'))
                        : null
            }
        };
    }
    return {
        headers: {}
    };
}
